/**
 * Product Additional Flavors Image Switcher
 * Handles dynamic image switching when flavor icons are clicked
 */
class ProductAdditionalFlavors {
  constructor() {
    this.init();
  }

  init() {
    this.bindFlavorClickEvents();
  }

  /**
   * Bind click events to flavor selector icons
   */
  bindFlavorClickEvents() {
    const flavorLinks = document.querySelectorAll(
      ".select__list--icons-item-anchor[data-flavor-handle]"
    );

    flavorLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleFlavorClick(link);
      });
    });
  }

  /**
   * Handle flavor icon click - switch main image and update active state
   * @param {HTMLElement} clickedLink - The clicked flavor link element
   */
  handleFlavorClick(clickedLink) {
    const flavorHandle = clickedLink.getAttribute("data-flavor-handle");
    const flavorImageSrc = clickedLink.getAttribute("data-flavor-image");
    const flavorName = clickedLink.getAttribute("data-flavor-name");

    console.log("Flavor clicked:", flavorHandle, flavorName, flavorImageSrc);

    // Switch the main image
    this.switchMainImage(flavorImageSrc, flavorName);

    // Update active state
    this.updateActiveFlavor(clickedLink);
  }

  /**
   * Switch the main flavor image
   * @param {string} newImageSrc - Source URL of the new image
   * @param {string} flavorName - Name of the flavor for alt text
   */
  switchMainImage(newImageSrc, flavorName) {
    const mainImage = document.querySelector(".flavor-main-image");

    if (!mainImage) {
      console.warn("Main flavor image not found");
      return;
    }

    if (!newImageSrc) {
      console.warn("No flavor image source provided");
      return;
    }

    // Change image immediately
    mainImage.src = newImageSrc;
    mainImage.alt = flavorName;
  }

  /**
   * Update the active flavor state (remove previous active, add to clicked)
   * @param {HTMLElement} clickedLink - The clicked flavor link element
   */
  updateActiveFlavor(clickedLink) {
    // Remove active state from all flavor icons
    const allFlavorIcons = document.querySelectorAll(
      ".select__list--icons-image-container"
    );
    allFlavorIcons.forEach((icon) => {
      icon.classList.remove("flavor-focus");
    });

    // Add active state to clicked flavor icon
    const clickedIcon = clickedLink.querySelector(
      ".select__list--icons-image-container"
    );
    if (clickedIcon) {
      clickedIcon.classList.add("flavor-focus");
    }
  }

  /**
   * Reinitialize the component (useful for dynamically loaded content)
   */
  reinit() {
    this.bindFlavorClickEvents();
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new ProductAdditionalFlavors();
});

// Also initialize if content is loaded dynamically
document.addEventListener("shopify:section:load", () => {
  new ProductAdditionalFlavors();
});

// Export for global access if needed
window.ProductAdditionalFlavors = ProductAdditionalFlavors;
